export const environment = {
    urlBackend: 'https://abopi-back-int.partner-informatique.fr/',
    urlKeycloak:'https://keycloak-int.partner-informatique.fr/',
    realmKeycloak:'INTERNAL-APP',
    urlKeycloakAccesToken: 'https://keycloak-int.partner-informatique.fr/realms/INTERNAL-APP/protocol/openid-connect/token',
    clientId: 'abopi',
    clientSecret: 'BrXUr0R49mGYpRG9b0rffiDZzMeA54q9',
    grantType: 'password',
    pointage: 'https://pointage-int.partner-informatique.fr'

};
